import { useSyncExternalStore } from "react";
import { taxPolicyStore } from "./index";
import type { TaxPolicy } from "./types";

function getSnapshot(): TaxPolicy[] {
  return taxPolicyStore.list();
}

const SERVER_SNAPSHOT: TaxPolicy[] = [];
function getServerSnapshot(): TaxPolicy[] {
  return SERVER_SNAPSHOT;
}

function subscribe(listener: () => void): () => void {
  return taxPolicyStore.subscribe(listener);
}

export interface UseTaxPoliciesResult {
  taxPolicies: TaxPolicy[];
  getById(id: string): TaxPolicy | undefined;
  refresh(): Promise<void>;
}

export function useTaxPolicies(): UseTaxPoliciesResult {
  const taxPolicies = useSyncExternalStore(
    subscribe,
    getSnapshot,
    getServerSnapshot,
  );
  return {
    taxPolicies,
    getById: (id: string) => taxPolicies.find((p) => p.id === id),
    refresh: () => taxPolicyStore.refresh(),
  };
}
